import { FiltersMap, TaskState } from '@wix/bex-core';
import { ToolbarCollectionState } from './ToolbarCollectionState';
import { ViewTypeState } from './ViewTypeState';

export interface ILayoutSwitchState<T, F extends FiltersMap> {
  readonly viewTypeState: ViewTypeState;
  readonly toolbar: ToolbarCollectionState<T, F>;
  readonly initTask: TaskState<unknown>;
  init(): void;
}
